import { render } from "./Csat.vue?vue&type=template&id=70358408"
import script from "./Csat.vue?vue&type=script&lang=js"
export * from "./Csat.vue?vue&type=script&lang=js"

import "./Csat.vue?vue&type=style&index=0&id=70358408&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__